import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class SalesItemActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Item/ItemBrowser")
	}

	render() {
		return (
			<Activity 
				name="SalesItem"
				RenderedComponent={this.RenderedComponent}
				context="SalesItem"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(SalesItemActivity)
